import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc, collection } from 'firebase/firestore';
import { db } from '../../firebase';
import DOMPurify from 'dompurify';
import './HotelRoomDetail.css';
import { useCollection } from 'react-firebase-hooks/firestore';
import { CiCalendarDate } from 'react-icons/ci';
import { Helmet } from 'react-helmet';
import Slider from 'react-slick';

export const HotelRoomDetail = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();

  const [room, setRoom] = useState(null);
  const [rooms, loading, error] = useCollection(collection(db, 'Rooms'));

  // Fetch the room details using roomId
  useEffect(() => {
    const fetchRoomDetails = async () => {
      try {
        const docRef = doc(db, 'Rooms', roomId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setRoom(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching document:', error);
      }
    };

    fetchRoomDetails();
  }, [roomId]);

  if (!room) {
    return <div>Loading...</div>;
  }

  // Handle the "Book Now" button click
  const handleBooking = (roomId, roomTitle) => {
    navigate(`/booking/${roomId}`, { state: { roomTitle } }); // Pass the room title via state
  };

  // Carousel settings for multiple images
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="hotelRoomDetail">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{room.title}</title>
        <meta name="description" content={room.description || 'Room details page'} />
      </Helmet>

      <div className="room-detail-hero">
        <div className="main-room-detail-title-hero">
          <h1 className="main-room-detail-title-hero-h1">{room.title}</h1>

          <div className="book-btn-container">
            <button
              onClick={() => handleBooking(roomId, room.title)}
              className="btn-book"
            >
              Book Now →
            </button>
          </div>
        </div>
      </div>

      <div className="room-details-sub">
        <div data-aos="fade-up" className="detail">
          {/* Check if there are multiple images for slider, otherwise display a single image */}
          {room.imageUrls && room.imageUrls.length > 1 ? (
            <Slider {...carouselSettings}>
              {room.imageUrls.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`image-${index}`}
                  className="room-card-image"
                  style={{ width: '100%', borderRadius: '10px' }}
                />
              ))}
            </Slider>
          ) : (
            <img
              src={room.imageUrls?.[0]}
              alt="Room Image"
              className="room-card-image"
              style={{ width: '100%', borderRadius: '10px' }}
            />
          )}

          <div className="data-text-container">
            <h2>{room.title}</h2>
            <p>{room.p1}</p>

            <div
              className="room-quill"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(room.content) }}
            />
          </div>
        </div>

        <div className="room-short-data">
          <button
            onClick={() => handleBooking(roomId, room.title)}
            className="btn-book"
          >
            Book Now →
          </button>

          <h2>Other Rooms</h2>

          <div>
            {loading && <p>Loading...</p>}
            {error && <p>Error fetching Rooms</p>}

            {rooms && (
              <div className="details-d1-room">
                {rooms.docs.map((room) => {
                  const data = room.data();
                  return (
                    <Link
                      style={{ textDecoration: 'none' }}
                      to={`/room/${room.id}`}
                      className="room-link"
                      key={room.id}
                    >
                      <div data-aos="fade-up" className="details-room-card">
                        <img
                          className="room-card-image"
                          src={data.iconImageUrl}
                          alt={data.title}
                          style={{ maxWidth: '100%' }}
                        />
                        <div className="details-room-data">
                          <h3 className="details-room-title">{data.title}</h3>
                          <p className="details-room-time">
                            <span className="room-icon">
                              <CiCalendarDate />
                            </span>
                            {data.timestamp &&
                              new Date(data.timestamp.toDate()).toLocaleString('en-US', {
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric',
                              })}
                          </p>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
